<template>
    <div class="img-border-box"><img :src="require(`@/assets/easy_payment/${src}`)" alt="" /></div>
</template>
<script>
export default {
    props: {
        src: {},
    },
};
</script>
<style lang="scss" scoped>
.img-border-box {
    height: 76px;
    border: 1px solid var(--border-color1);
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
